module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('md-card', {
    staticClass: "login-card"
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("CERTIFICAÇÃO DAS INSTALAÇÕES E EQUIPAMENTOS DO BLH")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Insira suas credenciais")])]), _vm._v(" "), _c('md-card-content', [_c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": "",
      "placeholder": "Digite seu email"
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Email obrigatório")])], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Senha")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": "",
      "type": "password",
      "placeholder": "Digite sua senha"
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Senha obrigatória")])], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])], 1)], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": "4000"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.erro))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "md-theme": "light-blue"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("FECHAR")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f20aa82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoginView.vue
// module id = 824
// module chunks = 1